import React from 'react';
import LayoutAbout from '../components/LayoutAbout'
const About=()=>(
    <LayoutAbout/>
)

export default About;